<template>
    <div class="p-4 d-flex justify-content-center align-items-center flex-column w-100">
        <div class="frame-image-capture">
            <img :src="image" ref="originalImage" alt="Captured Image" class="cs-image-capture" />
            <div class="corner top-left"></div>
            <div class="corner top-right"></div>
            <div class="corner bottom-left"></div>
            <div class="corner bottom-right"></div>
        </div>
        <div class="d-flex justify-content-center gap-5 py-4">
            <div class="d-flex flex-column align-items-center gap-2">
                <button @click="$emit('continue')" class="btn-continue">
                    <img width="24" height="24" src="@/static/eSim/svg/icon-arrow-right.svg" />
                </button>
                <p class="mb-0 text-primary text-capitalize">{{ $t('esim_continue') }}</p>
            </div>
            <div class="d-flex flex-column align-items-center gap-2">
                <button @click="$emit('retake')" class="btn-retake">
                    <img width="24" height="24" src="@/static/eSim/svg/icon-camera.svg" />
                </button>
                <p class="mb-0 text-primary">{{ $t('esim_retake') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from "vue";
import { Image } from "vant";
export default {
    name: "CaptureScreen",
    props: {
        image: String,
        activeStep: {
            type: Number,
            default: 0,
        },
    },
    components: {
        [Image.name]: Image,
    },
    data() {
        return {
            imageStyle: ref({}),
        };
    },
    mounted() {
        this.setupImageSize();
    },
    methods: {
        setupImageSize() {
            const imgEl = this.$refs.originalImage?.$el || this.$refs.originalImage
            if (!imgEl) return

            const onLoad = () => {
                this.imageStyle = {
                    width: imgEl.naturalWidth + 'px',
                    height: imgEl.naturalHeight + 'px',
                }
            }

            // Nếu ảnh đã load
            if (imgEl.complete || imgEl.naturalWidth) {
                onLoad()
            } else {
                imgEl.addEventListener('load', onLoad)
            }
        },
    },
    watch: {
        image() {
            // Reset và đợi ảnh mới load
            this.imageStyle = {}
            this.$nextTick(() => {
                this.setupImageSize()
            })
        },
    },
};
</script>

<style scoped>
.capture-screen {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.frame-image-capture {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.cs-image-capture {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
    image-rendering: auto;
}

.frame-image-capture .corner {
    position: absolute;
    width: 30px;
    height: 30px;
    border: 4px solid #9B9B9B;
}

.frame-image-capture .corner.top-left {
    top: 0;
    left: 0;
    border-right: none;
    border-bottom: none;
    border-top-left-radius: 5px;
}

.frame-image-capture .corner.top-right {
    top: 0;
    right: 0;
    border-left: none;
    border-bottom: none;
    border-top-right-radius: 5px;
}

.frame-image-capture .corner.bottom-left {
    bottom: 0;
    left: 0;
    border-right: none;
    border-top: none;
    border-bottom-left-radius: 5px;
}

.frame-image-capture .corner.bottom-right {
    bottom: 0;
    right: 0;
    border-left: none;
    border-top: none;
    border-bottom-right-radius: 5px;
}

.btn-continue {
    background-color: #C41627;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: background-color 0.3s, transform 0.3s;
}

.btn-retake {
    background-color: #FFF;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #C41627;
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: background-color 0.3s, transform 0.3s;
}
</style>